import { Box, Typography } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import {
  colorSurface,
  colorBorder,
  colorTextSecondary,
  radiusCard,
} from "src/design/tokens";
import { formatTime12h } from "../utils";

interface Props {
  selectedDate: Dayjs;
  selectedTime: string;
  guestCount: number;
}

const SummaryRow = ({
  icon,
  label,
}: {
  icon: React.ReactNode;
  label: string;
}) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
    {icon}
    <Typography variant="body2" color={colorTextSecondary}>
      {label}
    </Typography>
  </Box>
);

const BookingSummaryCard = ({
  selectedDate,
  selectedTime,
  guestCount,
}: Props) => {
  const { t } = useTranslation();

  const iconSx = { fontSize: 16, color: colorTextSecondary };

  return (
    <Box
      sx={{
        border: `1px solid ${colorBorder}`,
        borderRadius: radiusCard,
        backgroundColor: colorSurface,
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        mb: 2.5,
      }}
    >
      <SummaryRow
        icon={<CalendarTodayOutlinedIcon sx={iconSx} />}
        label={selectedDate.format("dddd, MMMM D, YYYY")}
      />
      <SummaryRow
        icon={<AccessTimeOutlinedIcon sx={iconSx} />}
        label={formatTime12h(selectedTime)}
      />
      <SummaryRow
        icon={<PeopleAltOutlinedIcon sx={iconSx} />}
        label={t("clientBooking.guestCountSummary", { count: guestCount })}
      />
    </Box>
  );
};

export default BookingSummaryCard;
